export const bannersData: IBanner[] = [
  {
    id: 'multicurrency',
    title: $localize`:@@banner.multicurrency_title:Now you can manage multiple currencies`,
    subtitle: $localize`:@@banner.multicurrency_subtitle:Manage conversions in various currencies easily with the new feature.`,
    img: 'assets/new-img/bg/bg-multicurrency-banner.png',
    enabledOnDashboard: false,
    enabledInNotifications: false,
    buttons: [
      {
        label: $localize`:@@banner.multicurrency_button:Learn More`,
        link: 'https://support.irev.com/en/articles/2224130',
      },
    ],
  },
  {
    id: 'dashboard-widgets',
    title: $localize`:@@banner.dashboard_widget_title:New Look & Long-Term Stats in Dashboard Widgets`,
    subtitle: $localize`:@@banner.dashboard_widget_subtitle:Experience easier navigation and powerful new insights`,
    img: 'assets/new-img/bg/bg-widgets-dashboard-banner.png',
    enabledOnDashboard: true,
    enabledInNotifications: true,
    buttons: [
      {
        label: $localize`:@@banner.dashboard_widget_button:Learn More`,
        link: 'https://support.irev.com/en/articles/2487042',
      },
    ],
  },
  {
    id: 'dashboard-drilldown',
    title: $localize`:@@banner.drilldown_title:Meet the Brand New Drilldown Report`,
    subtitle: $localize`:@@banner.drilldown_subtitle:Experience easier navigation and powerful new insights`,
    img: 'assets/new-img/bg/bg-drilldown-dashboard-banner.png',
    enabledOnDashboard: true,
    enabledInNotifications: true,
    buttons: [
      {
        label: $localize`:@@common.explore_now:Explore Now`,
        link: '/app/reporting/drilldown',
      },
    ],
  },
  {
    id: 'cohort',
    title: $localize`:@@banner.cohort_title:New Cohort Report`,
    subtitle: $localize`:@@banner.cohort_subtitle:Track affiliate performance over time with our new data analysis tool.`,
    img: 'assets/new-img/bg/bg-cohort-banner.png',
    enabledOnDashboard: true,
    enabledInNotifications: true,
    buttons: [
      {
        label: $localize`:@@common.try_now:Try Now`,
        link: '/app/reporting/cohort-report',
      },
    ],
  },
];

interface IBannerButton {
  label: string;
  link: string;
}

export interface IBanner {
  id: string;
  title: string;
  subtitle: string;
  img: string;
  enabledOnDashboard: boolean;
  enabledInNotifications: boolean;
  buttons: IBannerButton[];
}
